module.exports = __webpack_public_path__ + "img/southwest-winter-1920x550.2e347e67.jpg";